import * as types from './_actionTypes';

export const fetchStudentDashboardRequest = () => ({
  type: types.FETCH_STUDENT_DASHBOARD_REQUEST
});

export const fetchStudentDashboardSuccess = (data) => ({
  type: types.FETCH_STUDENT_DASHBOARD_SUCCESS,
  payload: data
});

export const fetchStudentDashboardFailure = (error) => ({
  type: types.FETCH_STUDENT_DASHBOARD_FAILURE,
  payload: error
});

export const updateStudentProgress = (progress) => ({
  type: types.UPDATE_STUDENT_PROGRESS,
  payload: progress
});